import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Group, Stack } from "@components/mantine";
import { forwardRef } from "react";
import { SourceIdentityCategoryIcon } from "./source-identity-category-icon/SourceIdentityCategoryIcon.js";
import { SourceIdentityCopyInfoButton } from "./source-identity-copy-info-button/SourceIdentityCopyInfoButton.js";
import { SourceIdentityName } from "./source-identity-name/SourceIdentityName.js";
import { SourceIdentityTypeImage } from "./source-identity-type-image/SourceIdentityTypeImage.js";
import { SourceIdentityTypeLabel } from "./source-identity-type-label/SourceIdentityTypeLabel.js";
import { SourceIdentityVisibilityIcon } from "./source-identity-visibility-icon/SourceIdentityVisibilityIcon.js";
import { useSourceIdentityContext } from "./SourceIdentityContext.js";
export var SourceIdentityListVariant = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var _children = _param.children, trackingHandler = _param.trackingHandler, props = _object_without_properties(_param, [
        "children",
        "trackingHandler"
    ]);
    var getStyles = useSourceIdentityContext().getStyles;
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        ref: ref,
        flex: 1
    }, getStyles("root"), props), {
        children: /*#__PURE__*/ _jsxs(Group, {
            align: "top",
            gap: "xs",
            children: [
                /*#__PURE__*/ _jsx(SourceIdentityTypeImage, {
                    size: "lg",
                    mt: "4px"
                }),
                /*#__PURE__*/ _jsxs(Stack, {
                    gap: 0,
                    children: [
                        /*#__PURE__*/ _jsxs(Group, {
                            gap: 0,
                            children: [
                                /*#__PURE__*/ _jsx(SourceIdentityName, {}),
                                /*#__PURE__*/ _jsx(SourceIdentityCopyInfoButton, {
                                    trackCopyInfoButton: trackingHandler === null || trackingHandler === void 0 ? void 0 : trackingHandler.trackCopyInfoButton
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SourceIdentityTypeLabel, {
                            size: "sm"
                        }),
                        /*#__PURE__*/ _jsxs(Group, {
                            align: "top",
                            gap: "xs",
                            children: [
                                /*#__PURE__*/ _jsx(SourceIdentityCategoryIcon, {
                                    showTooltip: true,
                                    size: "sm"
                                }),
                                /*#__PURE__*/ _jsx(SourceIdentityVisibilityIcon, {
                                    showTooltip: true,
                                    size: "sm"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
});
SourceIdentityListVariant.displayName = "@resourceIdentity/source/SourceIdentity/ListVariant";

//# sourceMappingURL=SourceIdentityListVariant.js.map